/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createIsBounded } from '../../factoriesNumber.js';
export var isBoundedDependencies = {
  typedDependencies,
  createIsBounded
};